import Router from 'utils/routing/router';

const App = () => <Router />;

export default App;
